import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/search';

const namespace = 'SKETCH';

export const FETCH_SEARCH_CONFIG_START = `${namespace}/FETCH_SEARCH_CONFIG_START`;
export const FETCH_SEARCH_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_CONFIG_SUCCESS`;
export const FETCH_SEARCH_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_CONFIG_ERROR`;

export const FETCH_SEARCH_RESULTS_CONFIG_START = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_START`;
export const FETCH_SEARCH_RESULTS_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_SUCCESS`;
export const FETCH_SEARCH_RESULTS_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_ERROR`;

export const FETCH_SKETCH_SETTINGS_START = `${namespace}/FETCH_SKETCH_SETTINGS_START`;
export const FETCH_SKETCH_SETTINGS_SUCCESS = `${namespace}/FETCH_SKETCH_SETTINGS_SUCCESS`;
export const FETCH_SKETCH_SETTINGS_ERROR = `${namespace}/FETCH_SKETCH_SETTINGS_ERROR`;

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const DELETE_SKETCH_START = `${namespace}/DELETE_SKETCH_START`;
export const DELETE_SKETCH_SUCCESS = `${namespace}/DELETE_SKETCH_SUCCESS`;
export const DELETE_SKETCH_ERROR = `${namespace}/DELETE_SKETCH_ERROR`;

export const EDIT_SKETCH_START = `${namespace}/EDIT_SKETCH_START`;
export const EDIT_SKETCH_SUCCESS = `${namespace}/EDIT_SKETCH_SUCCESS`;
export const EDIT_SKETCH_ERROR = `${namespace}/EDIT_SKETCH_ERROR`;

export const SAVE_SKETCH_START = `${namespace}/SAVE_SKETCH_START`;
export const SAVE_SKETCH_SUCCESS = `${namespace}/SAVE_SKETCH_SUCCESS`;
export const SAVE_SKETCH_ERROR = `${namespace}/SAVE_SKETCH_ERROR`;

export const SAVE_APPRAISAL_SKETCH_START = `${namespace}/SAVE_APPRAISAL_SKETCH_START`;
export const SAVE_APPRAISAL_SKETCH_SUCCESS = `${namespace}/SAVE_APPRAISAL_SKETCH_SUCCESS`;
export const SAVE_APPRAISAL_SKETCH_ERROR = `${namespace}/SAVE_APPRAISAL_SKETCH_ERROR`;

export const FETCH_SKETCH_NOTES_START = `${namespace}/FETCH_SKETCH_NOTES_START`;
export const FETCH_SKETCH_NOTES_SUCCESS = `${namespace}/FETCH_SKETCH_NOTES_SUCCESS`;
export const FETCH_SKETCH_NOTES_ERROR = `${namespace}/FETCH_SKETCH_NOTES_ERROR`;

export const SET_SKETCH_SETTINGS_START = `${namespace}/SET_SKETCH_SETTINGS_START`;
export const SET_SKETCH_SETTINGS_SUCCESS = `${namespace}/SET_SKETCH_SETTINGS_SUCCESS`;
export const SET_SKETCH_SETTINGS_ERROR = `${namespace}/SET_SKETCH_SETTINGS_ERROR`;

export const UPDATE_SKETCH_START = `${namespace}/UPDATE_SKETCH_START`;
export const UPDATE_SKETCH_SUCCESS = `${namespace}/UPDATE_SKETCH_SUCCESS`;
export const UPDATE_SKETCH_ERROR = `${namespace}/UPDATE_SKETCH_ERROR`;

export const UPDATE_APPRAISAL_SKETCH_START = `${namespace}/UPDATE_APPRAISAL_SKETCH_START`;
export const UPDATE_APPRAISAL_SKETCH_SUCCESS = `${namespace}/UPDATE_APPRAISAL_SKETCH_SUCCESS`;
export const UPDATE_APPRAISAL_SKETCH_ERROR = `${namespace}/UPDATE_APPRAISAL_SKETCH_ERROR`;

export const EDIT_COMMENT_START = `${namespace}/EDIT_COMMENT_START`;
export const EDIT_COMMENT_SUCCESS = `${namespace}/EDIT_COMMENT_SUCCESS`;
export const EDIT_COMMENT_ERROR = `${namespace}/EDIT_COMMENT_ERROR`;

export const POST_COMMENT_START = `${namespace}/POST_COMMENT_START`;
export const POST_COMMENT_SUCCESS = `${namespace}/POST_COMMENT_SUCCESS`;
export const POST_COMMENT_ERROR = `${namespace}/POST_COMMENT_ERROR`;

export const GET_COMMENTS_START = `${namespace}/GET_COMMENTS_START`;
export const GET_COMMENTS_SUCCESS = `${namespace}/GET_COMMENTS_SUCCESS`;
export const GET_COMMENTS_ERROR = `${namespace}/GET_COMMENTS_ERROR`;

export const DELETE_COMMENT_START = `${namespace}/DELETE_COMMENT_START`;
export const DELETE_COMMENT_SUCCESS = `${namespace}/DELETE_COMMENT_SUCCESS`;
export const DELETE_COMMENT_ERROR = `${namespace}/DELETE_COMMENT_ERROR`;

export const POST_TAG_START = `${namespace}/POST_TAG_START`;
export const POST_TAG_SUCCESS = `${namespace}/POST_TAG_SUCCESS`;
export const POST_TAG_ERROR = `${namespace}/POST_TAG_ERROR`;

export const GET_TAGS_START = `${namespace}/GET_TAGS_START`;
export const GET_TAGS_SUCCESS = `${namespace}/GET_TAGS_SUCCESS`;
export const GET_TAGS_ERROR = `${namespace}/GET_TAGS_ERROR`;

export const DELETE_TAG_START = `${namespace}/DELETE_TAG_START`;
export const DELETE_TAG_SUCCESS = `${namespace}/DELETE_TAG_SUCCESS`;
export const DELETE_TAG_ERROR = `${namespace}/DELETE_TAG_ERROR`;

export const SKETCH_QUERY_START = `${namespace}/SKETCH_QUERY_START`;
export const SKETCH_QUERY_SUCCESS = `${namespace}/SKETCH_QUERY_SUCCESS`;
export const SKETCH_QUERY_ERROR = `${namespace}/SKETCH_QUERY_ERROR`;

export const GET_IMPROVEMENTS_START = `${namespace}/GET_IMPROVEMENTS_START`;
export const GET_IMPROVEMENTS_SUCCESS = `${namespace}/GET_IMPROVEMENTS_SUCCESS`;
export const GET_IMPROVEMENTS_ERROR = `${namespace}/GET_IMPROVEMENTS_ERROR`;

export const SET_INITIAL_SKETCH_DATA_START = `${namespace}/SET_INITIAL_SKETCH_DATA_START`;
export const SET_INITIAL_SKETCH_DATA_SUCCESS = `${namespace}/SET_INITIAL_SKETCH_DATA_SUCCESS`;
export const SET_INITIAL_SKETCH_DATA_ERROR = `${namespace}/SET_INITIAL_SKETCH_DATA_ERROR`;

export const SET_INITIAL_SKETCH_MODIFIER = `${namespace}/SET_INITIAL_SKETCH_MODIFIER`;

export const fetchSketchNotes = makeApiActionCreatorV3(
  api.fetchSketchNotes,
  FETCH_SKETCH_NOTES_START,
  FETCH_SKETCH_NOTES_SUCCESS,
  FETCH_SKETCH_NOTES_ERROR,
);

export const deleteSketch = makeApiActionCreatorV3(
  api.deleteSketch,
  DELETE_SKETCH_START,
  DELETE_SKETCH_SUCCESS,
  DELETE_SKETCH_ERROR,
);

export const editSketch = makeApiActionCreatorV3(
  api.editSketch,
  EDIT_SKETCH_START,
  EDIT_SKETCH_SUCCESS,
  EDIT_SKETCH_ERROR,
);

export const fetchSearchConfig = makeApiActionCreatorV3(
  api.fetchSearchConfig,
  FETCH_SEARCH_CONFIG_START,
  FETCH_SEARCH_CONFIG_SUCCESS,
  FETCH_SEARCH_CONFIG_ERROR,
);

export const fetchSearchResultsConfig = makeApiActionCreatorV3(
  api.fetchSearchResultsConfig,
  FETCH_SEARCH_RESULTS_CONFIG_START,
  FETCH_SEARCH_RESULTS_CONFIG_SUCCESS,
  FETCH_SEARCH_RESULTS_CONFIG_ERROR,
);

export const fetchSketchSettings = makeApiActionCreatorV3(
  api.fetchSketchSettings,
  FETCH_SKETCH_SETTINGS_START,
  FETCH_SKETCH_SETTINGS_SUCCESS,
  FETCH_SKETCH_SETTINGS_ERROR,
);

export const saveSketch = makeApiActionCreatorV3(
  api.saveSketch,
  SAVE_SKETCH_START,
  SAVE_SKETCH_SUCCESS,
  SAVE_SKETCH_ERROR,
);

export const saveAppraisalSketch = makeApiActionCreatorV3(
  api.saveAppraisalSketch,
  SAVE_APPRAISAL_SKETCH_START,
  SAVE_APPRAISAL_SKETCH_SUCCESS,
  SAVE_APPRAISAL_SKETCH_ERROR,
);

export const setSketchSettings = makeApiActionCreatorV3(
  api.setSketchSettings,
  SET_SKETCH_SETTINGS_START,
  SET_SKETCH_SETTINGS_SUCCESS,
  SET_SKETCH_SETTINGS_ERROR,
);

export const updateAppraisalSketch = makeApiActionCreatorV3(
  api.updateAppraisalSketch,
  UPDATE_APPRAISAL_SKETCH_START,
  UPDATE_APPRAISAL_SKETCH_SUCCESS,
  UPDATE_APPRAISAL_SKETCH_ERROR,
);

export const updateSketch = makeApiActionCreatorV3(
  api.updateSketch,
  UPDATE_SKETCH_START,
  UPDATE_SKETCH_SUCCESS,
  UPDATE_SKETCH_ERROR,
);

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const editComment = makeApiActionCreatorV3(
  api.editComment,
  EDIT_COMMENT_START,
  EDIT_COMMENT_SUCCESS,
  EDIT_COMMENT_ERROR,
);

export const postComment = makeApiActionCreatorV3(
  api.postComment,
  POST_COMMENT_START,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_ERROR,
);

export const getComments = makeApiActionCreatorV3(
  api.getComments,
  GET_COMMENTS_START,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_ERROR,
);

export const deleteComment = makeApiActionCreatorV3(
  api.deleteComment,
  DELETE_COMMENT_START,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_ERROR,
);

export const postTag = makeApiActionCreatorV3(
  api.postTag,
  POST_TAG_START,
  POST_TAG_SUCCESS,
  POST_TAG_ERROR,
);

export const getTags = makeApiActionCreatorV3(
  api.getTags,
  GET_TAGS_START,
  GET_TAGS_SUCCESS,
  GET_TAGS_ERROR,
);

export const deleteTag = makeApiActionCreatorV3(
  api.deleteTag,
  DELETE_TAG_START,
  DELETE_TAG_SUCCESS,
  DELETE_TAG_ERROR,
);

export const setInitialSketchData = makeApiActionCreatorV3(
  api.editSketch,
  SET_INITIAL_SKETCH_DATA_START,
  SET_INITIAL_SKETCH_DATA_SUCCESS,
  SET_INITIAL_SKETCH_DATA_ERROR,
);

export const sketchQuery = makeApiActionCreatorV3(
  api.sketchQuery,
  SKETCH_QUERY_START,
  SKETCH_QUERY_SUCCESS,
  SKETCH_QUERY_ERROR,
);

export const getImprovements = makeApiActionCreatorV3(
  api.getImprovements,
  GET_IMPROVEMENTS_START,
  GET_IMPROVEMENTS_SUCCESS,
  GET_IMPROVEMENTS_ERROR,
);

export function setInitialSketchModifier(modifier) {
  return async dispatch => {
    dispatch({ type: SET_INITIAL_SKETCH_MODIFIER, sketchData: modifier });
  };
}
